<template>
  <!-- 下发通知 -->
  <div class="edu_pages">
    <div class="edu_pages_content_box">
      <div class="edu_page_title_box">
        <div class="title_box" v-if="eduInfo.eduBuresuType == 0">
          <div class="color_lump_box"></div>
          <span>消息通知</span>
        </div>
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          v-else
        >
          <el-menu-item index="1">下发通知</el-menu-item>
          <el-menu-item index="2">上级通知</el-menu-item>
        </el-menu>
        <div class="edu_operation_box" v-if="activeIndex == 1">
          <el-radio-group class="select-radio" v-model="identification" size="mini">
            <el-radio-button :label="1">教育局</el-radio-button>
            <el-radio-button :label="2">学校</el-radio-button>
          </el-radio-group>
          <div
            class="add_icon_box button-box"
            @click="openAddBox('school')"
            v-if="eduInfo.eduBuresuType == 3"
          >
            <div></div>
            <span>新增</span>
          </div>
          <el-dropdown v-else>
            <div class="add_icon_box button-box">
              <div></div>
              <span>新增</span>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <span @click="openAddBox('school')">下发学校</span>
              </el-dropdown-item>
              <el-dropdown-item
                ><span @click="openAddBox('edu')">下发机构</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <send-notices
        v-if="activeIndex == 1"
        ref="send"
        :identification="identification"
      ></send-notices>
      <accept-notices v-if="activeIndex == 2" ref="accept"></accept-notices>
      <!-- <div class="edu_pages_content_body_box">
        <div class="edu_table_box">
          <el-table
            :data="resData.list"
            height="100%"
            :header-cell-style="{ background: '#DDE4FF', color: '#474859' }"
            class="table_box"
          >
            <el-table-column prop="id" label="序号" width="70" align="center">
              <template slot-scope="scope">
                {{ reqData.pageSize * (reqData.pageNum - 1) + scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column
              prop="headline"
              label="标题"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="message"
              label="消息内容"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column prop="identification" label="消息类型" align="center">
              <template slot-scope="scope">
                {{ scope.row.identification == 1 ? "教育局" : "学校" }}
              </template>
            </el-table-column>
            <el-table-column
              prop="timestamp"
              label="发送时间"
              align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{ $Common.dateFormatDateTwo(scope.row.timestamp) }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="180" align="center">
              <template slot-scope="scope">
                <el-link type="primary" @click="checkClick(scope.row)" :underline="false"
                  >查看状态</el-link
                >
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="edu_pagination_box" v-if="resData.total > 0">
          <el-pagination
            @current-change="handleCurrentChange"
            background
            :current-page="reqData.pageNum"
            :page-size="reqData.pageSize"
            layout="total, prev, pager, next, jumper"
            :total="resData.total"
          >
          </el-pagination>
        </div>
      </div> -->
    </div>
    <index-add :addResize="addResize" :addType="addType" @addList="addList"></index-add>
    <!-- <notices-list :noticesResize="noticesResize" :selObj="selObj"></notices-list> -->
  </div>
</template>

<script>
import indexAdd from "./components/indexAdd.vue";
import noticesList from "./components/noticesList.vue";
import sendNotices from "./components/sendNotices.vue";
import acceptNotices from "./components/acceptNotices.vue";
export default {
  name: "",
  components: {
    indexAdd,
    noticesList,
    sendNotices,
    acceptNotices,
  },
  props: {},
  data() {
    return {
      eduInfo: JSON.parse(sessionStorage.getItem("eduInfo")),
      activeIndex: "1",
      identification: 1,
      reqData: {
        senderId: this.$store.getters.getEduData.eduId,
        identification: 1,
        pageNum: 1,
        pageSize: 20,
      },
      resData: {
        pageSize: 0,
        pageNum: 0,
        total: 0,
        pages: 0,
        list: [],
      },
      addResize: 0,
      addType: "school",
      noticesResize: 0,
      selObj: {
        identification: "",
        notificationId: "",
      },
    };
  },
  watch: {},
  computed: {},
  methods: {
    // clearData() {
    //   this.actionDataInfo = {
    //     eduId: this.$store.getters.getEduData.eduId,
    //     title: "",
    //     startTime: "",
    //     endTime: "",
    //     projectIds: "",
    //     inspectionTeamIds: "",
    //   };
    // },
    // hand切换
    handleSelect(val) {
      this.activeIndex = val;
      // this.reqData.identification = val;
      // this.getList();
    },
    openAddBox(type) {
      this.addType = type;
      this.addResize++;
      // this.actionDataBox = true;
      // setTimeout(() => {
      //   this.$refs.ruleForm.resetFields();
      // }, 100);
    },
    // checkClick(item) {
    //   // console.log(item, 11111);
    //   this.selObj = item;
    //   this.noticesResize++;
    //   // this.$Common.updateNoticesStatus(item.notificationId, 2);
    // },
    // cancelForm() {
    //   this.actionDataBox = false;
    //   this.$refs.ruleForm.resetFields();
    //   this.clearData();
    // },
    // handleCurrentChange(val) {
    //   this.reqData.pageNum = val;
    //   console.log(`当前页: ${val}`);
    //   this.getDataList();
    // },
    addList() {
      if (this.addType == "school") {
        // console.log(222222222);
        this.reqData.identification = 2;
      } else {
        // console.log(1111111111);
        this.reqData.identification = 1;
      }
      this.$refs.send.getList();
    },
    // getList() {
    //   this.reqData.pageNum = 1;
    //   this.getDataList();
    // },
    // async getDataList() {
    //   let res = await this.$Http.getEduNoticesList(this.reqData);
    //   if (res.code == 200) {
    //     this.resData.pageSize = res.data.pageSize;
    //     this.resData.pageNum = res.data.pageNum;
    //     this.resData.total = res.data.total;
    //     this.resData.pages = res.data.pages;
    //     this.resData.list = res.data.list;
    //   } else if (res.code == 101) {
    //     this.resData.total = 0;
    //     this.resData.list = [];
    //   } else {
    //     this.$message({
    //       message: res.messsage,
    //       type: "error",
    //     });
    //   }
    // },
  },
  created() {
    // this.getDataList();
  },
  mounted() {},
};
</script>
<style scoped lang="scss">
@import "../../../../../public/css/edu_pages.scss";
.el-menu-item {
  height: 50px !important;
  line-height: 50px !important;
}
.select-radio {
  height: 26px;
  /deep/ .el-radio-button__inner {
    padding: 6px 15px;
  }
}
</style>
